import { render } from "./detail.vue?vue&type=template&id=c24ee062&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=c24ee062&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24ee062"],['__file',"src/views/food/dish/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c24ee062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c24ee062', __exports__)) {
    console.log('reload')
    api.reload('c24ee062', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=c24ee062&scoped=true", () => {
    console.log('re-render')
    api.rerender('c24ee062', render)
  })

}


export default __exports__